
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import 'firebase/auth';
import Layout from 'containers/Layout';
import React from 'react';
import { doc } from 'services/db/firestoreApi';
import { restExecutor } from 'services/rest-executor/executor';
import { GetServerSidePropsContext } from 'next';
import { getServerSideCustomer } from 'ssr';
import { StateStatus } from 'core/design/StateStatus';
import { SETTINGS_GET } from 'redux/constants/settings';
import { PROMOTED_RESTAURANTS_GET, RESTAURANTS_GET } from 'redux/constants/restaurants';
import { CURRENT_USER_GET } from 'redux/constants/users';
import { _generateToken } from 'services/cart/useCartService/token';
import { staticMetaContent } from 'static/meta';
import { pickBy, values } from 'lodash';
import { settingsPath } from 'services/settings-path';
import { SectionSettings } from 'klikni-jadi-shared-stuff';
import { SECTIONS_GET } from 'redux/constants/sections';
import PartnersContainer from 'containers/partners/PartnersContainer';
import router from 'next/router';

export default function Partners({ routerQuery, url }) {
    return (
        <Layout
            showHeaderSearch
            routerQuery={routerQuery}
            showFooter={false}
            transparentSearch={false}
            url={url}
            metaTags={staticMetaContent['listings']}
            // metaKey="listings"
        >
            <PartnersContainer routerQuery={routerQuery} discover={true} />
        </Layout>
    );
}

// Listings.getInitialProps = async function (ctx) {
//     const reduxStore = initializeStore({});
//     const { dispatch } = reduxStore;
//     const query = ctx.query;

//     const executor = restExecutor('/properties');

//     const filters: any = await doc('settings', 'filters');
//     const search = await executor.get({
//         type: typeMapper[query.type || 'delivery'],
//         occupationId: query.occupationId,
//         cuisineId: query.cuisineId,
//         search: query.search,
//     });

//     await dispatch(settingsFirestoreActions.success(filters));
//     await dispatch(restaurantsFirestoreActions.all.success(search.data));

//     return {
//         routerQuery: ctx.query || {},
//         initialReduxState: reduxStore.getState(),
//     };
// };

const typeMapper = {
    delivery: 'delivery',
    bookatable: 'booking',
    takeout: 'takeout',
    else: null,
};

 async function _getServerSideProps(context: GetServerSidePropsContext) {
    const executor = restExecutor('/restaurants', 'v2');
    const executorPromoted = restExecutor('/restaurants/promoted');

    const query = context.query || {};
    const _token = await _generateToken();
    const filters: any = await doc(settingsPath(query.city as string), 'filters');

    const executorFilters = restExecutor('/restaurants/filters', 'v2');

    const _res = await executorFilters.get({
        type: 'delivery',
        city: query.city,
    });

    const sectionFilters = _res.data || {};

    const data = await getServerSideCustomer(context);

    const successObject = {
        data: null,
        errors: null,
        version: +new Date(),
        status: StateStatus.LOADED,
    };

    let nearby = query.nearby;

    if (!nearby && data.customer) {
        const defaultAddress = values(data.customer.addresses).find(address => address.isDefault);
        let userAddress = defaultAddress;
        if (!userAddress) {
            userAddress = values(data.customer.addresses)?.[0];
        }
        if (userAddress) {
            nearby = `${userAddress.location.latitude}, ${userAddress.location.longitude}`;
        }
    }

    const sections = await doc<SectionSettings>(settingsPath(query.city as string), 'sections');
    const activeSections = values(pickBy(sections, s => s.active));

    const _sectionsData = [];
    for (let i = 0; i < activeSections.length; i++) {
        const section = activeSections[i];
        const _executor = restExecutor(`/restaurants/sections/${section.id}`, 'v2');
        const _response = await _executor.get({
            region: query.city,
            'service-type': 'delivery',
            nearby,
            'section-type': section.type,
        });

        if (_response.success) {
            _sectionsData.push({
                section,
                partners: _response.data.data,
                openIds: _response.data.openIds || [],
                closedIds: _response.data.closedIds || [],
            });
        }
    }

    // console.log('SECTIONS DATA', JSON.stringify(_sectionsData));

    // If all restaurants are closed, redirect to /partners?... instead /partners/discover?...
    if (_sectionsData.length == 0) {
        const partnersUrl = '/partners?' + context.resolvedUrl.split('?')[1];
        return {
            redirect: {
                destination: partnersUrl,
                permanent: false,
            },
        };
    }

    // console.log('data: ', {
    //     type: typeMapper[(query.type as string) || 'else'] || 'delivery',
    //     occupationId: query.occupationId,
    //     cuisineId: query.cuisineId,
    //     q: query.search ? encodeURIComponent(query.search as string) : null,
    //     amenityIds: query.amenitiesIds,
    //     page: 1,
    //     nearby,
    // });

    // console.log('search', search);

    return {
        props: {
            url: context.resolvedUrl,
            routerQuery: query || {},
            authenticated: data.authenticated,
            uid: data.uid,
            initialReduxState: {
                settingsFilters: {
                    ...successObject,
                    data: filters,
                    entity: SETTINGS_GET.entity,
                },
                currentUser: {
                    ...successObject,
                    data: JSON.parse(JSON.stringify(data.customer)),
                    entity: CURRENT_USER_GET.entity,
                    status: data.customer ? StateStatus.LOADED : StateStatus.NOT_INITIALIZED,
                },
                sections: {
                    ...successObject,
                    entity: SECTIONS_GET.entity,
                    data: {
                        data: _sectionsData,
                        filters: sectionFilters.data || {},
                    },
                },
            },
        },
    };
}


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/partners/discover',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  